<template>
  <Register data-fn-location="register"/>
</template>

<script>
import Register from '../components/templates/Register'
import translate from '@/language';

export default {
  metaInfo: {
    title: `${translate('', 'register')} - Finnomena`
  },
  components: {
    Register
  }
}
</script>
